import { load } from 'recaptcha-v3';

const RECPATCHA_FIELD = 'recpatchaSiteKey';

const getEnquiryForm = (form?: HTMLFormElement | null) =>
    form ||
    (document.querySelector('.off-canvas-panel form') as HTMLFormElement) ||
    (document.querySelector('.modal form') as HTMLFormElement) ||
    (document.querySelector('.page-container form') as HTMLFormElement);

export const displayResponse = function (data, form?: HTMLFormElement | null) {
    const enquiryForm = getEnquiryForm(form);
    const alertSuccess = enquiryForm?.querySelector('.alert-success') as HTMLElement;
    const alertError = enquiryForm?.querySelector('.alert-danger') as HTMLElement;

    if (!alertSuccess || !alertError) return;

    alertSuccess.classList.add('hidden');
    alertError.classList.add('hidden');

    if (data.success) alertSuccess.classList.remove('hidden');
    else {
        let errorMessage = '';
        data.errors.forEach(error => {
            const message = typeof error === 'string' ? error : error.description;
            errorMessage += `<p>* ${message}</p>`;
            alertError.innerHTML = errorMessage;
        });
        alertError.classList.remove('hidden');
    }
};

export const recaptchaFunction = async function () {
    const recaptchaId = (document.getElementById(RECPATCHA_FIELD) as HTMLInputElement).value;
    const recaptcha = await load(recaptchaId);
    const token = await recaptcha.execute('submit');

    let result = await fetch("/api/recaptcha", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ token: token })
    }).then(r => { return r.json(); });

    return result;
};
